module.exports = __webpack_public_path__ + "img/apple.909452f4.png";